<template>
  <div class="documentation-list-content">
    <div class="documentation-list-content__item">
      <DocumentationListItemHeader :date="documentation.date" />
      <DocumentationListItemDetails
        :description="documentation.description"
        :attachment-groups="documentation.attachmentGroups"
        :legacy-attachments="documentation.legacyAttachments"
        :supplier-id="supplierId"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ServiceOffer } from "@/custom-types/serviceOffers";
import DocumentationListItemHeader from "./DocumentationListItemHeader.vue";
import DocumentationListItemDetails from "./DocumentationListItemDetails.vue";

interface Props {
  documentation: {
    description: string | null;
    attachmentGroups?: ServiceOffer["supplierRequestAttachmentGroups"];
    legacyAttachments?: ServiceOffer["supplierRequestAttachments"];
    date: string;
  };
  supplierId: number;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.documentation-list-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &__item {
    background: $color-white;
    border: 1px solid $color-border-light;
    border-radius: 8px;
    padding: 1.5rem;

    @media (max-width: $bp-sm) {
      padding: 1rem;
    }
  }
}
</style>
